import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/404-dark.png'
import _imports_1 from '@/assets/img/404.png'


const _hoisted_1 = { class: "page_error" }
const _hoisted_2 = {
  key: 0,
  class: "img-404",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "img-404",
  src: _imports_1
}
const _hoisted_4 = { class: "error-title" }
const _hoisted_5 = { class: "error-desc" }
const _hoisted_6 = { class: "error-tip" }

import useDownloadApp from '@/hooks/useDownloadApp'
  import { useDark } from '@vueuse/core'
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'page-error',
  setup(__props) {

  const route = useRoute()

  const isDark = useDark({
    selector: 'html',
    attribute: 'data-theme',
    valueDark: 'dark',
    valueLight: 'light',
  })

  const { downloadApp } = useDownloadApp()

  onMounted(() => {
    if (route.query.theme === 'dark') {
      isDark.value = true
    } else {
      isDark.value = false
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isDark))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('你的链接出现了问题')), 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('很遗憾，您的链接有问题。请检查并重试，或让你的朋友重新发送')), 1),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('了解更多，请')), 1),
      _createElementVNode("span", {
        style: {"color":"#38bdf8"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downloadApp)()))
      }, _toDisplayString(_ctx.$t('下载 Envo')), 1)
    ])
  ]))
}
}

})